module.exports = __webpack_public_path__ + "static/media/kfsw.54b37287.mp4";